// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'shared/components/Icon';

/** @typedef {{
  value?: string,
  icon?: string,
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>,
  containerClassName?: string,
  className?: string,
  onChange?: (newValue: string) => void,
  onBlur?: (e: any) => void,
  onFocus?: (e: any) => void
}} InputTextProps */

/** @type { React.ValidationMap<InputTextProps> } */
const propTypes = {
  value: PropTypes.string,
  icon: PropTypes.string,
  inputProps: PropTypes.object,
  containerClassName: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};

/** @type { React.SFC<InputTextProps> } */
const InputText = props => {
  const {
    value,
    onChange,
    onBlur,
    onFocus,
    icon,
    inputProps = {},
    containerClassName = '',
    className = '',
  } = props;

  function handleChange(evt) {
    if (onChange) onChange(evt.target.value);
  }

  /**
   * NB: `type` and `className` can both be overridden by `inputProps`.
   */

  return (
    <div style={{ position: 'relative' }} className={containerClassName}>
      <input
        type="text"
        value={value || ''}
        onChange={handleChange}
        onBlur={onBlur}
        onFocus={onFocus}
        className={`input-large ${className}`}
        style={{
          margin: 0,
          paddingLeft: '2.5rem',
          paddingTop: '0.5rem',
          paddingBottom: '0.5rem',
          boxSizing: 'border-box',
          width: '100%',
          height: 'auto',
        }}
        {...inputProps}
      />
      {icon && (
        <div className="text-gray-500" style={{}}>
          <Icon
            name={icon}
            style={{
              position: 'absolute',
              top: '50%',
              left: '0.75rem',
              transform: 'translateY(-50%)',
              width: '1.25rem',
              height: '1.25rem',
            }}
          />
        </div>
      )}
    </div>
  );
};

InputText.propTypes = propTypes;

export { InputText };
